import MuiBreadcrumbs, { BreadcrumbsProps } from '@mui/material/Breadcrumbs';
import { SxProps, Theme } from '@mui/material/styles';
import { mdiChevronRight } from '@mdi/js';

import { Icon } from 'common/components/Icon';
import { withSxProp } from 'common/utils/props';

const breadcrumbsStyle: SxProps<Theme> = {
    color: 'text.primary',
    minWidth: 0,
    '& .MuiBreadcrumbs-ol': {
        flexWrap: 'nowrap',
    },
    '& .MuiBreadcrumbs-li': {
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
    },
    // Only the last crumb gets an ellipsis when space runs out.
    '& .MuiBreadcrumbs-li:last-of-type': {
        minWidth: 0,
        flexShrink: 1,
        '& > *': {
            display: 'inline-block',
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        },
    },
    '& .MuiBreadcrumbs-separator': {
        mx: 0,
        flexShrink: 0,
        color: 'text.secondary',
    },
};

export const Breadcrumbs = ({ sx, ...props }: BreadcrumbsProps) => (
    <MuiBreadcrumbs
        separator={<Icon path={mdiChevronRight} size="1.9rem" />}
        sx={[breadcrumbsStyle, ...withSxProp(sx)]}
        {...props}
    />
);
